import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const UserkeyDelete = ({
  isOpen,
  toggle,
  reload,
  bookingId,
  keyId,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenKeyDeleteSuccessModal, setIsOpenKeyDeleteSuccessModal ] = useState(false);
  const [ isOpenKeyDeleteFailModal, setIsOpenKeyDeleteFailModal ] = useState(false);
  const [ messageKeyDeleteFail, setMessageKeyDeleteFail ] = useState('');

  const deleteKey = async () => {
    try {
      setIsLoading(true);
      await api.deleteUserMobilekey({bookingId, keyId});
      toggle();
      setIsOpenKeyDeleteSuccessModal(true);
      setTimeout(() => {
        setIsOpenKeyDeleteSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      toggle();
      if (!error.response) setMessageKeyDeleteFail(error.message);
      else setMessageKeyDeleteFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenKeyDeleteFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <FontAwesomeIcon icon={faQuestionCircle} style={{fontSize:'5em', color:'orange'}}/>
          <p className='mb-0 mt-4' style={{fontSize:'15px'}}>
            {t('confirm_message.delete_key')}<br/>
          </p>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={deleteKey}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenKeyDeleteSuccessModal}
        toggle={() => setIsOpenKeyDeleteSuccessModal(!isOpenKeyDeleteSuccessModal)}
        message={t('success_message.delete_key')}
      />
      <ResponseFailModal
        isOpen={isOpenKeyDeleteFailModal}
        toggle={() => setIsOpenKeyDeleteFailModal(!isOpenKeyDeleteFailModal)}
        message={messageKeyDeleteFail || t('error_message.delete_key')}
      />
    </Fragment>
  );
}

export default UserkeyDelete;